import React, { useCallback, useMemo, useState } from 'react';
import { arrayOf, func, string } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Table } from 'antd';
import { Card } from '@cards/Card';
import { pathwayRuleType, whenType } from '../../../../../propTypes';
import SelectRulesModal from '../StagedRules/SelectRulesModal';
import createColumns from './createColumns';

function AddRulesToIndexEvent({
  defaultFilteredValue,
  filters,
  selectedRules,
  title,
  addRules,
  removeRule,
}) {
  const [isSelectRuleVisible, setIsSelectRuleVisible] = useState(false);
  const { t } = useTranslation();
  const columns = useMemo(() => createColumns(t), [t]);
  const dataSource = useMemo(
    () => selectedRules.map(rule => ({ ...rule, onDelete: () => removeRule(rule.id) })),
    [selectedRules, removeRule],
  );
  const toggleSelectRule = useCallback(() => setIsSelectRuleVisible(!isSelectRuleVisible), [
    isSelectRuleVisible,
  ]);

  return (
    <>
      <Card.Full
        className="staged-rules-card"
        extra={
          <>
            <Button icon="plus" type="dashed" onClick={toggleSelectRule}>
              {t('pathways:ProcedurePathways.wizard.stagedRules.addRule')}
            </Button>
            {/* <Button icon="plus" type="dashed">
              {t('pathways:ProcedurePathways.wizard.stagedRules.createARule')}
            </Button> */}
          </>
        }
        title={title}
      >
        <Table columns={columns} dataSource={dataSource} pagination={false} rowKey="id" />
      </Card.Full>
      {isSelectRuleVisible ? (
        <SelectRulesModal
          defaultFilteredValue={defaultFilteredValue}
          filters={filters}
          selectedRules={selectedRules}
          onCancel={toggleSelectRule}
          onOk={addRules}
          audienceTypesToFilter={['clinician']}
        />
      ) : null}
    </>
  );
}

AddRulesToIndexEvent.propTypes = {
  filters: arrayOf(whenType),
  selectedRules: arrayOf(pathwayRuleType).isRequired,
  title: string.isRequired,
  addRules: func.isRequired,
};

AddRulesToIndexEvent.defaultProps = {
  filters: [],
};

export default AddRulesToIndexEvent;
